module.exports = __webpack_public_path__ + "img/freevip2.7bc6063f.jpg";